import { render, staticRenderFns } from "./EventsCalendar.vue?vue&type=template&id=3da87674&scoped=true"
import script from "./EventsCalendar.vue?vue&type=script&lang=js"
export * from "./EventsCalendar.vue?vue&type=script&lang=js"
import style0 from "./EventsCalendar.vue?vue&type=style&index=0&id=3da87674&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3da87674",
  null
  
)

export default component.exports